import { render, staticRenderFns } from "./ProductManual.vue?vue&type=template&id=adf7c78c&scoped=true&"
import script from "./ProductManual.vue?vue&type=script&lang=js&"
export * from "./ProductManual.vue?vue&type=script&lang=js&"
import style0 from "./ProductManual.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductManual.vue?vue&type=style&index=1&id=adf7c78c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf7c78c",
  null
  
)

export default component.exports